import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaList, FaPencilAlt, FaPlus, FaPowerOff } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';
import { NavLink } from 'react-router-dom';

import ColdDataApi from '../../api/ColdDataApi';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import ApiUiController from '../../controller/ApiUiController';
import CampaignRenamePopup from "../cold_data/CampaignRenamePopup";

class ColdDataList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inApiCall: true, 
      activeTab: 'active',
      activeCampaigns: [],
      deactiveCampaigns: [],
      popup:false,
      nameToEdit: "",
      campaignIdToEdit: 0,
      loadedTabs: { active: false, deactive: false }
    };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).cold_data;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
  }

  componentDidMount() { 
    if(this.List) {
      // Load both tabs immediately
      this.loadActiveCampaigns();
      this.loadDeactiveCampaigns();
    }
  }

  loadActiveCampaigns = () => {
    const { loadedTabs } = this.state;
    if (loadedTabs.active) return;

    this.setState({ inApiCall: true });

    let user = undefined;
    if(this.Restrict) {
       const loggedUser = reactLocalStorage.getObject(Const.LoggedInUser);
  user = loggedUser?.user_id; 
    }
    

    ColdDataApi.getList(
      user,
      (data) => {
        this.setState({ 
          activeCampaigns: data,
          loadedTabs: { ...loadedTabs, active: true },
          inApiCall: false
        });
      },
      () => {
        this.setState({ inApiCall: false });
      }
    );
  }

  loadDeactiveCampaigns = () => {
    const { loadedTabs } = this.state;
    if (loadedTabs.deactive) return;

    this.setState({ inApiCall: true });

    let user = undefined;
    if(this.Restrict) {
      const loggedUser = reactLocalStorage.getObject(Const.LoggedInUser);
  user = loggedUser?.user_id;
    }

    ColdDataApi.getDeactivateList(
      user,
      (data) => {
        this.setState({ 
          deactiveCampaigns: data,
          loadedTabs: { ...loadedTabs, deactive: true },
          inApiCall: false
        });
      },
      () => {
        this.setState({ inApiCall: false });
      }
    );
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  }

  details = id => {
    if(this.Restrict) {
      this.props.navigate(`${this.path}/campaign/data/${id}`);
    } else {
      this.props.navigate(`${this.path}/campaign/${id}`);
    }
  }

  deactivate = id => {
    const { activeCampaigns } = this.state;
    const campaign = activeCampaigns.find(c => c.id === id);

    if (!campaign) return;

    Util.confirmAlert(
      "Deactivate Campaign",
      `Are you sure you want to deactivate "${campaign.name}"?`,
      "Yes, Deactivate",
      "Cancel",
      () => {
        ColdDataApi.DeactivateCampaign(
          campaign.id,
          () => {
            this.setState(prevState => ({
              activeCampaigns: prevState.activeCampaigns.filter(c => c.id !== id),
              deactiveCampaigns: [
                ...prevState.deactiveCampaigns,
                { ...campaign, status: 2 }
              ]
            }), () => {
              Util.showNotification(
                "Successful",
                "Campaign deactivated successfully.",
                "success"
              );
            });
          },
          (err) => {
            Util.showNotification(
              "Error",
              "Failed to deactivate campaign: " + err,
              "danger"
            );
          }
        );
      }
    );
  }

  activate = id => {
    const { deactiveCampaigns } = this.state;
    const campaign = deactiveCampaigns.find(c => c.id === id);

    if (!campaign) return;

    Util.confirmAlert(
      "Activate Campaign",
      `Are you sure you want to activate "${campaign.name}"?`,
      "Yes, Activate",
      "Cancel",
      () => {
        ColdDataApi.ActivateCampaign(
          campaign.id,
          () => {
            this.setState(prevState => ({
              deactiveCampaigns: prevState.deactiveCampaigns.filter(c => c.id !== id),
              activeCampaigns: [
                ...prevState.activeCampaigns,
                { ...campaign, status: 1 }
              ]
            }), () => {
              Util.showNotification(
                "Successful",
                "Campaign activated successfully.",
                "success"
              );
            });
          },
          (err) => {
            Util.showNotification(
              "Error",
              "Failed to activate campaign: " + err,
              "danger"
            );
          }
        );
      }
    );
  }

  onRename = (id, res) => {
    let campaign = this.state.activeCampaigns.filter((cam) => cam.id === id)?.[0];
    if(!campaign) return;
    campaign = {
      ...campaign,
      name: res ? res : campaign.name
    };
    const updatedActiveCampaigns = this.state.activeCampaigns.map((camp) => {
      if(camp.id === campaign.id) return campaign;
      else return camp;
    })
    this.setState({ activeCampaigns: updatedActiveCampaigns, popup: false });
  }

  renderRows = (campaigns, isActiveTab = true) => {
    if (!campaigns.length)
      return <tr><td colSpan="7" className="text-center">No Records Found</td></tr>;

    return campaigns.map((list, _i) => (
      <tr key={`campaign_${list.id}`}>
        <td>{_i + 1}</td>
        <td>{list.name}</td>
        <td>{list.complete_status === 1 ? 'Successful' : 'In Progress'}</td>
        <td>{list.total_call}</td>
        <td>{Util.serverStringToDisplayDateTime(list.created_date)}</td>
        <td>
          <span 
            className="mr-8-important btn btn-primary btn-sm me-2"
            onClick={() => this.details(list.id)}
            style={{ cursor: 'pointer' }}
          >
            <FaList /> Details
          </span>

          {isActiveTab && this.Delete && Number(list.status) === 1 ? (
            <span 
              className="mr-8-important btn btn-danger btn-sm me-2" 
              onClick={() => this.deactivate(list.id)}
              style={{ cursor: 'pointer' }}
            >
              <FaPowerOff /> Deactivate
            </span>
          ): null }

          {isActiveTab && this.Update && Number(list.status) === 1 && (
            <span 
              className="btn btn-warning btn-sm me-2 text-white" 
              onClick={() => this.setState({ popup: true, nameToEdit: list.name, campaignIdToEdit: list.id })}
              style={{ cursor: 'pointer' }}
            >
              <FaPencilAlt color="#ffffff" /> Rename
            </span>
          )}

          {!isActiveTab && this.Delete && Number(list.status) === 2 ? (
            <span 
              className="mr-8-important btn btn-success btn-sm me-2" 
              onClick={() => this.activate(list.id)}
              style={{ cursor: 'pointer' }}
            >
              <FaPowerOff /> Activate
            </span>
          ) : null }
        </td>
      </tr>
    ));
  }
  
  render() {
    if(!this.List) return null;
    
    const { activeTab, activeCampaigns, deactiveCampaigns, inApiCall } = this.state;

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 mb-3 d-flex justify-content-between align-items-center">
              <h3 className="m-0">Call Campaign</h3>
              <NavLink 
                to={`/setting/import/add?model=${Const.ColdData}`} 
                className="buttons add"
              >
                <FaPlus /> Upload Call Data
              </NavLink>
            </div>

            <div className="col-md-12 mb-3">
              <div className="d-flex gap-2">
                <button
                  className={`mr-8-important btn ${activeTab === 'active' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => this.handleTabChange('active')}
                >
                  Active Campaigns ({activeCampaigns.length})
                </button>

                <button
                  className={`mr-8-important btn ${activeTab === 'deactive' ? 'btn-danger' : 'btn-outline-danger'}`}
                  onClick={() => this.handleTabChange('deactive')}
                >
                  Deactivated Campaigns ({deactiveCampaigns.length})
                </button>
              </div>
            </div>

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Name</th>
                    <th>Complete Status</th>
                    <th>Total Data</th>
                    <th>Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ApiUiController inApiCall={inApiCall}>
                    {activeTab === 'active'
                      ? this.renderRows(activeCampaigns, true)
                      : this.renderRows(deactiveCampaigns, false)
                    }
                  </ApiUiController>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        
        <CampaignRenamePopup 
          name={this.state.nameToEdit} 
          id={this.state.campaignIdToEdit} 
          show={this.state.popup} 
          onRename={this.onRename} 
          onHide={() => this.setState({ popup: false })} 
        />
      </div>
    );
  }
}

export default withRouter(ColdDataList);